'use strict';

define('features/slp/form',[
  'jquery',
  'txt!./form.hbs',
  'txt!./satd.time.hbs',
  './vehicle.picker',
  './vehicle.offer',
  './details',
  './dealer',
  './set.campaign.code',
  'lib/util/tda.config',
  'lib/services/batws',
  'detectizr',
  'cookies',
  'lib/getParameterByName',
  'bat',
  'lib/scroller',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/click.manual',
  'lib/analytics/context.add',
  'webStorage',

  // side effect includes
  'jqueryui',
  'Handlebars',
  'lib/helpers/ifCond',
  'dropkick',
  'lib/validator'
], function (
  $,
  txtTemplate,
  txtSatdTime,
  VehiclePicker,
  VehicleOffer,
  Details,
  Dealers,
  setCampaignCode,
  tdaConfig,
  batws,
  detectizr,
  cookies,
  getParameterByName,
  bat,
  scroller,
  blocks,
  anPageLoad,
  anClicks,
  anClickManual,
  anAddContext,
  ws
) {
  var __tmplForm = Handlebars.compile(txtTemplate);
  var __tmplSatdTime = Handlebars.compile(txtSatdTime);
  var __offerId = getParameterByName('offerid');
  // TODO: Change in XSL and drop this map?
  var __typeMap = {
    'request-a-quote': 'request-a-quote',
    'schedule-a-test-drive': 'schedule-a-test-drive',
    'contact-a-dealer': 'contact-dealer'
  };

  var __kmMap = {
    'request-a-quote': 'raq',
    'schedule-a-test-drive': 'satd',
    'contact-a-dealer': 'cad'
  };

  function __formToObj(form) {
    var formPostObj = {};
    form.serializeArray().forEach(function (input) {
      if (input.value) {
        formPostObj[input.name] = input.value;
      }
    });
    return formPostObj;
  }

  // Need to append any SATD vals, offer details and referring URL to comments
  function __xformCommentsVal(formVals) {
    var commentStr = formVals.commentArea || '';
    if (formVals.preferredDate) {
      commentStr += ' | Customer Requests to Schedule-A-Test-Drive on ';
      commentStr += formVals.preferredDate + ' ' + formVals.preferredTime + '.';
    }
    if (formVals.offer) {
      commentStr += ' | ' + formVals.offer;
    }
    return commentStr + ' ::REFERRING URL:: ' + document.URL;
  }

  function __isStandAlone() {
    var path = window.location.pathname;
    return path.indexOf('request-a-quote') > -1
      || path.indexOf('contact-dealer') > -1
      || path.indexOf('schedule-a-test-drive') > -1;
  }

  var SLPForm = function (el, config) {
    this.$el = $(el);
    this.config = $.extend({}, SLPForm.defaults, config);
  };

  // Potential formLength vals from XSL: 'default' or 'short'
  SLPForm.defaults = {
    formLength: 'default',
    formType: 'request-a-quote'
  };

  $.extend(SLPForm.prototype, {
    load: function () {
      var self = this;
      this.$el.html(__tmplForm({ i18n: self.config.i18n }));
      this.$form = this.$el.parent('form');
      this.$vehicleEl = $('.js-slp-vehicle', this.$el);
      this.$detailsEl = $('.js-slp-details', this.$el);
      this.$dealersEl = $('.js-slp-dealers', this.$el);
      this.$satdTimeEl = $('.js-slp-satd-time', this.$el);

      /*
        An SLP form is made up of three sections
        Vehicle | Details | Dealer
        Vehicle and Dealer are potentially async.
        Vehicle is either a Vehicle Picker or a vehicle "Offer card"
      */
      this.buildVehicle()
        .then(function () {
          self.buildDetails().load(); // sync
          self.addSatdTime(); // sync
          self.formListeners(); // sync
          return self.buildDealerSearch().load(); // async, returns promise obj
        })
        .then(function () {
          self.analyticsAsyncsDone(); // all of our async work is done
        })
        .catch(function (err) {
          console.error('err in SLPForm buildVehicle: ', err); // eslint-disable-line no-console
        });
    },

    // Need to build either a 'Vehicle Picker' view or an 'Offer Card' view in the 'Select Your Vehicle' section
    // Either ones .load() method returns a promise obj
    buildVehicle: function () {
      if (__offerId && this.config.formType === 'request-a-quote') {
        return new VehicleOffer(this.$vehicleEl, $.extend({}, this.config, this.config.vehicle))
          .load();
      }
      return new VehiclePicker(this.$vehicleEl, $.extend({}, this.config, this.config.vehicle))
        .load();
    },

    buildDetails: function () {
      this.details = new Details(this.$detailsEl, $.extend({}, this.config, this.config.details));
      return this.details;
    },

    buildDealerSearch: function () {
      this.dealerSearch = new Dealers(this.$dealersEl, $.extend({}, this.config, this.config.dealers));
      return this.dealerSearch;
    },

    addSatdTime: function () {
      var config = this.config;
      if (config.formType === 'schedule-a-test-drive') {
        this.$satdTimeEl.html(__tmplSatdTime({ i18n: this.config.i18n }));
        $('.date-picker', this.$el)
          .datepicker({
            minDate: new Date()
          })
          .datepicker('setDate', '0');
        $('#ui-datepicker-div', this.$el).hide();
        $('#time-of-day', this.$el).dropkick();
      }
    },

    formListeners: function () {
      var self = this;
      self.$form.validate({
        errorClass: 'ui-state-error',
        onfocusout: function (el) { $(el).valid(); },
        rules: {
          customerZipCode: {
            zipcodeUS: true
          },
          customerEmail: {
            email: true
          },
          customerPhone: {
            phoneUS: true
          },
          dealerZip: {
            zipcodeUS: true
          }
        },
        invalidHandler: function (event, validator) {
          self.analyticsFormError(validator);
          self.analyticsUser();
        },
        submitHandler: function () {
          self.analyticsFormError();
          self.analyticsUser();
          self.sendPostToElms();
        }
      });

      self.$form.on('submit', function (e) {
        e.preventDefault();
        anPageLoad($('#' + self.config.formType));
      });
    },

    sendPostToElms: function () {
      var self = this;
      var config = self.config;
      var formPostObj = __formToObj(self.$form);
      // Need to xform or create specific pieces of additional form data
      var req = {
        deviceType: detectizr.device.type,
        mediaTag: cookies.getItem('campaign'),
        omnitureId: cookies.getItem('xact'),
        tmsSiteAttribute: config.TMSSiteAttribute,
        campaignCode: setCampaignCode(
          __typeMap[config.formType],
          config.formLength,
          self.details.didUseFacebook()
        ),
        comments: __xformCommentsVal(formPostObj),
        errorPage: window.location.origin + '/' + tdaConfig.site.context_url + '/' + __typeMap[config.formType] + '/404/',
        successPage: window.location.origin + '/' + tdaConfig.site.context_url + '/' + __typeMap[config.formType] + '/thankyou/',
        vehicleMake: 'Toyota',
        vehicleInterest: 'buy',
        vehicleStatus: 'new',
        exteriorColor: '',
        interiorColor: '',
        vehicleYear: formPostObj.vehicleYear || 'N/A',
        vehicleModel: formPostObj.vehicleModel || 'N/A',
        vehicleTrim: formPostObj.vehicleTrim || 'N/A',
      };
      var finalReq = Object.assign({}, formPostObj, req);
      console.log('finalReq', finalReq); // eslint-disable-lin no-console

      bat.util.loader.showLoader();
      batws.slp().getQuote(finalReq)
        .then(function () {
          ws.getSessionStorage().setItem('customerFirstName', finalReq.customerFirstName);
          // res is just a string of HTML from the success page
          // if error, will we get the same thing?
          // TODO: Here is really where we want to trigger pageload with km-raq-complete...
          var successUrl = finalReq.successPage + '?dealercode=' + finalReq.dealerCode;
          // need to let the thank you page if user did NOT select a series
          if (finalReq.noVehicle === 'on') {
            successUrl += '&noseries';
          }
          window.location = successUrl;
        })
        .catch(function (err) {
          console.log('err: ', err); // eslint-disable-line no-console
          window.location = finalReq.errorPage;
        });
    },

    analyticsFormError: function (validator) {
      var $scope = $('#' + this.config.formType);
      var invalids;
      if (validator) {
        invalids = validator.invalid;
      }
      anAddContext($scope, blocks.errorSlpBlock(invalids));
    },

    analyticsUser: function () {
      var $scope = $('#' + this.config.formType);
      var formPostObj = __formToObj(this.$form);
      anAddContext($scope, blocks.userBlock({
        preferedContact: formPostObj.preferedContact,
        customerCity: formPostObj.customerCity,
        customerState: formPostObj.customerState,
        customerZipCode: formPostObj.customerZipCode,
        preferredTime: formPostObj.preferredTime,
        preferredDate: formPostObj.preferredDate
      }));
    },

    analyticsAsyncsDone: function () {
      var self = this;
      var $scope = $('#' + self.config.formType);
      var metrics = 'km-' + __kmMap[self.config.formType] + '-shown';
      var hasDealers = self.dealerSearch.hasDealers();
      if (hasDealers) {
        metrics += ',km-dealer-search';
      }
      anAddContext(
        $scope,
        blocks.sectionBlock(__typeMap[self.config.formType])
      );

      // Until scroller gets "better", if this form is on a page, need to just fire pageLoad
      // if it's a component, need to add as scroll listener
      if (__isStandAlone()) {
        anPageLoad($scope, blocks.keyMetrics(metrics));
      } else {
        scroller.add($scope, {
          tolerance: 300,
          after: function () {
            anPageLoad($scope, blocks.keyMetrics(metrics));
          }
        });
      }
      anClicks($scope);
      self.$form.one('click', 'input, .dk-select, a, button', function (event) {
        var $selector = $(event.target);
        $selector.data('km', 'km-' + __kmMap[self.config.formType] + '-start'); // TODO: Why do this instead of addContext?
        anClickManual($scope, $selector);
      });
    }
  });

  return SLPForm;
});

